module.exports = __webpack_public_path__ + "static/img/logo.312c704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/logo.png
// module id = ihTa
// module chunks = 76